import image1 from "../assets/t-image1.jpg";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";
import image4 from "../assets/t-image4.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I am so glad I chose XrFitSync Club and selected the perfect plan and program for my fitness journey. I've already achieved my dream physique!",
    name: "HRITHIK ROSHAN",
    status: "BOLLYWOOD ACTOR",
  },
  {
    image: image2,
    review:
      " Joining XrFitSync Club was a game-changer for me! The personalized training programs and supportive community have pushed me to new heights in my fitness journey.",
    name: "VIDYUT JAMMWAL",
    status: "MARTIAL ARTIST AND ACTOR",
  },
  {
    image: image3,
    review:
      " XrFitSync Club has transformed my approach to training! The expert guidance and dynamic workouts have made a significant difference in my performance on the mat",
    name: "VINESH FOOGAT",
    status: "INDIAN WRESTLER CHAMPPION",
  },
  {
    image: image4,
    review:
      " Training at XrFitSync Club has been an incredible experience! The energy, variety of programs, and motivating trainers have helped me achieve my fitness goals like never before.",
    name: "TIGER  SHROFF",
    status: "BOLLYWOOD ACTOR",
  },
];
